// extracted by mini-css-extract-plugin
export default {"container":"SoftLaunchTable_container__84yPH","powerScoreContainer":"SoftLaunchTable_powerScoreContainer__hYrrW","ribbon":"SoftLaunchTable_ribbon__By9U9"};